import React from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

export const FormIcon = ({ name, size, top, color, style, iconStyle = 'fas' }) => {
    if (name) {
        return (
            <FontAwesomeIcon 
                icon={[iconStyle, name]}
                style={{ marginTop: top, fontSize: size, marginRight: 15, color: color, ...style }}
            />
        );
    }
};
// THIS NEEDS TO BE REFACTORED TO BE A STYLED COMPONENT


// WEBPACK FOOTER //
// ./src/js/components/Form/FormIcon.jsx